import { styled as muiStyled } from '@mui/material/styles';
import { spacing, SpacingProps } from '@mui/system';

/**
 * Convenient spacing values that can be used with V2 theme which uses a
 * scaling factor of 4.
 *
 * @example
 *   // within styled-component
 *   theme.spacing(spc.xxs) => `${4 * 2}px` = '8px'
 *   // using MUI size props
 *   //   padding: 8px;
 *   <button sx={{ p: spc.xxs }} />
 */
export const spc = {
  xxxs: 1,
  xxs: 2,
  xs: 4,
  s: 6,
  m: 8,
  l: 10,
  xl: 12,
  xxl: 14,
  xxxl: 16,
  /**
   * Spacing between containers
   */
  between_vertical_xs: 2,
  between_vertical_s: 4,
  between_vertical_m: 8,
  between_vertical_l: 12,
  between_horizontal_s: 6,
  /**
   * container paddings
   */
  container_padding_s: 2,
  container_padding_m: 4,
  container_padding_l: 6,
  /**
   * button spacing
   */
  button_vertical_s: 3,
  button_horizontal_s: 4,
  button_vertical_l: 6,
  button_horizontal_l: 6,
  /**
   * Spacing between buttons
   */
  button_between_horizontal_s: 3,
};

interface Props extends SpacingProps {}

/**
 * Equivalent of a div with MUI spacing properties
 *
 * @example
 *   <Spacer p={spc.xxs} />
 */
export const Spacer = muiStyled('div')<Props>`
  ${spacing}
`;

export default Spacer;
